import { render, staticRenderFns } from "./CommentBar.vue?vue&type=template&id=49c9c45f&scoped=true&"
import script from "./CommentBar.vue?vue&type=script&lang=js&"
export * from "./CommentBar.vue?vue&type=script&lang=js&"
import style0 from "./CommentBar.vue?vue&type=style&index=0&id=49c9c45f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9c45f",
  null
  
)

export default component.exports